import * as bucketConstants from '../constants/buckets';

export default function membersOfBuckets(state = { loading: {} }, action) {
    switch (action.type) {
        case bucketConstants.FETCH_BUCKET_MEMBERS_REQUEST: {
            const { bucketId } = action.payload;
            return {
                ...state,
                error: undefined,
                loading: {
                    ...state.loading,
                    [bucketId]: true,
                },
            };
        }
        case bucketConstants.FETCH_BUCKET_MEMBERS_SUCCESS: {
            const { bucketId } = action.payload;
            return {
                ...state,
                error: undefined,
                loading: {
                    ...state.loading,
                    [bucketId]: false,
                },
            };
        }
        case bucketConstants.FETCH_BUCKET_MEMBERS_FAILURE: {
            const { bucketId, error } = action.payload;
            return {
                ...state,
                error: error,
                loading: {
                    ...state.loading,
                    [bucketId]: false,
                },
            };
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/membersOfBucketsReducer.js